var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.zhStringToYear = exports.zhStringToNumber = exports.WEEKDAY_OFFSET = exports.NUMBER = void 0;
  exports.NUMBER = {
    "\u96F6": 0,
    "\u4E00": 1,
    "\u4E8C": 2,
    "\u5169": 2,
    "\u4E09": 3,
    "\u56DB": 4,
    "\u4E94": 5,
    "\u516D": 6,
    "\u4E03": 7,
    "\u516B": 8,
    "\u4E5D": 9,
    "\u5341": 10,
    "\u5EFF": 20,
    "\u5345": 30
  };
  exports.WEEKDAY_OFFSET = {
    "\u5929": 0,
    "\u65E5": 0,
    "\u4E00": 1,
    "\u4E8C": 2,
    "\u4E09": 3,
    "\u56DB": 4,
    "\u4E94": 5,
    "\u516D": 6
  };
  function zhStringToNumber(text) {
    let number = 0;
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      if (char === "\u5341") {
        number = number === 0 ? exports.NUMBER[char] : number * exports.NUMBER[char];
      } else {
        number += exports.NUMBER[char];
      }
    }
    return number;
  }
  exports.zhStringToNumber = zhStringToNumber;
  function zhStringToYear(text) {
    let string = "";
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      string = string + exports.NUMBER[char];
    }
    return parseInt(string);
  }
  exports.zhStringToYear = zhStringToYear;
  //# sourceMappingURL=constants.js.map
  return exports;
}